import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addTransaction,
  deleteTransaction,
  editTransaction,
  getBalance,
  getTransactions
} from "./transactionAPI";

const initialState = {
  transactions: [],
  balance: "",
  isLoading: false,
  isError: false,
  error: "",
  editing: {},
  type: "",
  search: "",
  pageNo: 1,
  totalCount: 0,
};

// async thunks
export const fetchTransactions = createAsyncThunk(
  "transaction/fetchTransactions",
  async ({ isLimit, type, search, pageNo }) => {
    const transactions = await getTransactions({
      isLimit,
      type,
      search,
      pageNo,
    });
    return transactions;
  }
);

export const geTotalBalance = createAsyncThunk(
  "transaction/getBalance",
  async () => {
    const mainBalance = await getBalance();
    return mainBalance;
  }
);

export const createTransaction = createAsyncThunk(
  "transaction/createTransaction",
  async (data) => {
    const transaction = await addTransaction(data);
    return transaction;
  }
);

export const changeTransaction = createAsyncThunk(
  "transaction/changeTransaction",
  async ({ id, data }) => {
    const transaction = await editTransaction(id, data);
    return transaction;
  }
);

export const removeTransaction = createAsyncThunk(
  "transaction/removeTransaction",
  async (id) => {
    const transaction = await deleteTransaction(id);
    return transaction;
  }
);

// create slice
const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    editActive: (state, action) => {
      state.editing = action.payload;
    },
    editInActive: (state) => {
      state.editing = {};
    },
    selectedType: (state, action) => {
      if (state?.type === action?.payload) {
        state.type = "";
      } else {
        state.type = action.payload;
      }
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    reset: (state) => {
      state.search = "";
      state.type = "";
    },
    currentPageNo: (state, action) => {
      state.pageNo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.transactions = action.payload.transactions;
        state.totalCount = action.payload.total_count;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.transactions = [];
      })
      .addCase(createTransaction.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createTransaction.fulfilled, (state, action) => {
        console.log(action);
        state.isError = false;
        state.isLoading = false;
        state.transactions.push(action.payload.create);
        state.transactions = action.payload.landingData;
      })
      .addCase(createTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(changeTransaction.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(changeTransaction.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        const indexToUpdate = state.transactions.findIndex(
          (t) => t.id === action.payload.id
        );
        state.transactions[indexToUpdate] = action.payload;
      })
      .addCase(changeTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeTransaction.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(removeTransaction.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.transactions = action.payload.landingData;
        state.totalCount = action.payload.total_count;
        state.pageNo = 1;
      })
      .addCase(removeTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(geTotalBalance.pending, (state) => {
        state.isError = false;
        state.isLoading = false;
      })
      .addCase(geTotalBalance.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.balance = action.payload;
      })
      .addCase(geTotalBalance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default transactionSlice.reducer;
export const {
  editActive,
  editInActive,
  selectedType,
  searched,
  reset,
  currentPageNo,
} = transactionSlice.actions;
